import React from 'react';
import './Contact.scss'

export const Contact = () => {
  return (
    <div className="Contact">
      <p>For all bookings/comments/questions/concerns:</p>
      <a href="mailto:smalltimenapoleonband@gmail.com">smalltimenapoleonband@gmail.com</a>
    </div>
  )
}